import ValidService from "../../../service/ValidService";
let model = {};

// dữ liệu form
model.dataForm = {
    first_name: null, // Tên bác sĩ
    last_name: null, // Họ
    hospital_code: null, // Mã bệnh viện
    license_code: null, // Số chứng chỉ hành nghề
    hospital_name: null
};

// validation form
model.validForm = {
    first_name: [ValidService.required], // Tên bác sĩ
    last_name: [], // Họ
    hospital_code: [ValidService.required], // Mã bệnh viện
    license_code: [ValidService.required], // Số chứng chỉ hành nghề
    hospital_name: []
};


// validation các form khác
model.validFormOther = {
};


model.tableRules = {
    data: [],
    lengthMenu: [10, 20, 50, 100, 500],
    allowPaging: true,
    allowSorting: true,
    allowSelect: false,
    showFormSearch: false,
    showUrl: true,
    total: 0,
    page: 1,
    limit: 10,
    offset: 0,
    sort: "",
    defaultSort: ["created_time", "descending"],
    filters: "",
    recordSelected: [],
    dataSearch: {
        value: {
            first_name: null,
            last_nane: null,
            hospital_code: null,
            license_code: null
        },
        valid: {
            first_name: [],
            last_name: [],
            hospital_code: [],
            license_code: []
        },
        operator: {
            first_name: ":regex_i:",
            last_name: ":regex_i",
            hospital_code: ":in:",
            license_code: ":in:"
        }
    }
};

export default model;